import { url } from "inspector";
import axiosInstance from "../../environment/axiosInstances";

export const adminUsersServices = {
    searchAgent,
    editAgent,
    searchDepartment,
    editDepartment,
    searchPhoneNumber,
    editPhoneNumber,
    searchAddon,
    searchTicket,
    searchWhite,
    searchOutBound,
    searchE99Providers,
    searchOutBoundCallLogs,
    searchInBound,
    searchInBoundgetIP,
    searchSms,
    VendorRate,
    AllCall,
    UsageReport,
    editAddon,
    searchSmsReports,
    VendorReports,
    callSimuation,
    searchPhoneNumberAssigned,
    searchPhoneNumberCancelled,
    searchPhoneNumberDeleted,
    searchPhoneNumberPort,
    editSmsProvider,
    efoneClients,
    deviceProvision,
    EditDeviceProvision,
    profileModules,
    editProfile,
    permissionSearch,
    UserPermssion
}

function efoneClients(data: any) {
    const addons = data.addons?.length > 0 ? data.addons.map((dt: any) => dt).join(',') : data.addons
    if (Object.keys(data).length) {
        return axiosInstance.get(`/admin/efone-clients?limit=50&page=${data.pageLimit}&${data.typeData}=${data.type}&${data.searchValueData}=${data.value}&${data.accountTypeData}=${data.accountType}&${data.statusData}=${data.status}&${data.e911StatusData}=${data.e911Status}&${data.addonsData}=${addons}&${data.smsStatusData}=${data.smsStatus}`);
    } else {
        return axiosInstance.get(`/admin/efone-clients?limit=50&page=${data}`);
    }
}


function searchAgent(data: any) {
    if (Object.keys(data).length) {
        return axiosInstance.get(`/admin/admin-users?limit=50&page=${data.pageLimit}&${data.id}=${data.searchValue}`);
    } else {
        return axiosInstance.get(`/admin/admin-users?limit=50&page=${data}`);
    }
}

function editAgent(data: any) {
    return axiosInstance.get(`/admin/admin-users/${data.id}`);
}

function searchDepartment(data: any) {
    if (Object.keys(data).length) {
        return axiosInstance.get(`/admin/departments?limit=50&page=${data.pageLimit}&${data.id}=${data.searchValue}`);
    }
    else {
        return axiosInstance.get(`/admin/departments?limit=50&page=${data}`);
    }
}

function editDepartment(data: any) {
    return axiosInstance.get(`/admin/departments/${data.id}`);
}

function searchPhoneNumber(data: any) {
    let url = `/admin/phone-numbers?limit=50&page=${data.pageLimit}`
    if (data.phoneNumber && data.phoneNumberData) {
        url += `&${data.phoneNumber}=${data.phoneNumberData}`
    }
    if (data.ispremium) {
        url += `&isPremium=${data.ispremium}`;
    }
    if (data.providerId && data.providerIdData) {
        url += `&${data.providerId}=${data.providerIdData}`
    }
    if (data.status && data.statusData) {
        url += `&${data.status}=${data.statusData}`
    }
    if (data.smsStatusData && data.smsStatus) {
        url += `&${data.smsStatusData}=${data.smsStatus}`
    }
    if (data.typeData && data.type) {
        url += `&${data.typeData}=${data.type}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/phone-numbers?limit=50&page=${data}`);
    }
}

function editPhoneNumber(data: any) {
    return axiosInstance.get(`/admin/phone-numbers/${data.id}`);
}

function searchPhoneNumberAssigned(data: any) {
    let url= `/admin/phone-numbers/assigned-numbers?limit=50&page=${data.pageLimit}`
    if (data.phoneNumber && data.phoneNumberData) {
        url += `&${data.phoneNumber}=${data.phoneNumberData}`
    }
    if (data.providerId && data.providerIdData) {
        url += `&${data.providerId}=${data.providerIdData}`
    }
    if (data.status && data.statusData) {
        url += `&${data.status}=${data.statusData}`
    }
    if (data.smsStatusData && data.smsStatus) {
        url += `&${data.smsStatusData}=${data.smsStatus}`
    }
    if (data.typeData && data.type) {
        url += `&${data.typeData}=${data.type}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/phone-numbers/assigned-numbers?limit=50&page=${data}`);
    }
}

function searchPhoneNumberCancelled(data: any) {
    let url = `/admin/phone-numbers/cancelled-numbers?limit=50&page=${data.pageLimit}`
    if(data.phoneNumber && data.phoneNumberData){
        url += `&${data.phoneNumber}=${data.phoneNumberData}`
    }
    if(data.providerId && data.providerIdData){
        url += `&${data.providerId}=${data.providerIdData}`
    }
    if(data.status && data.statusData){
        url += `&${data.status}=${data.statusData}`
    }
    if(data.smsStatusData && data.smsStatus){
        url += `&${data.smsStatusData}=${data.smsStatus}`
    }
    if(data.typeData && data.type){
        url += `&${data.typeData}=${data.type}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/phone-numbers/cancelled-numbers?limit=50&page=${data}`);
    }
}

function searchPhoneNumberDeleted(data: any) {
    let url = `/admin/phoneNumbers/deletedPhoneNumbers?limit=50&page=${data.pageLimit}`
    if(data.phoneNumber && data.phoneNumberData){
        url += `&${data.phoneNumber}=${data.phoneNumberData}`
    }
    if(data.providerId && data.providerIdData){
        url += `&${data.providerId}=${data.providerIdData}`
    }
    if(data.status && data.statusData){
        url += `&${data.status}=${data.statusData}`
    }
    if(data.smsStatusData && data.smsStatus){
        url += `&${data.smsStatusData}=${data.smsStatus}`
    }
    if(data.typeData && data.type){
        url += `&${data.typeData}=${data.type}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/phoneNumbers/deletedPhoneNumbers?limit=50&page=${data}`);
    }
}

function searchPhoneNumberPort(data: any) {
    let url = `/admin/phone-numbers/port-numbers?limit=50&page=${data.pageLimit}`
    if(data.phoneNumber && data.phoneNumberData){
        url += `&${data.phoneNumber}=${data.phoneNumberData}`
    }
    if(data.providerId && data.providerIdData){
        url += `&${data.providerId}=${data.providerIdData}`
    }
    if(data.status && data.statusData){
        url += `&${data.status}=${data.statusData}`
    }
    if(data.smsStatusData && data.smsStatus){
        url += `&${data.smsStatusData}=${data.smsStatus}`
    }
    if(data.typeData && data.type){
        url += `&${data.typeData}=${data.type}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/phone-numbers/port-numbers?limit=50&page=${data}`);
    }
}

function searchAddon(data: any) {
    let url = `/admin/addons?limit=50&page=${data.pageLimit}`
    if (data.addonName && data.addonNameData) {
        url += `&${data.addonName}=${data.addonNameData}`
    }
    if (data.addonId && data.addonIdData) {
        url += `&${data.addonId}=${data.addonIdData}`
    }
    if (data.addonType && data.addonTypeData) {
        url += `&${data.addonType}=${data.addonTypeData}`
    }
    if (data.isICA && data.isICAData) {
        url += `&${data.isICA}=${data.isICAData}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/addons?limit=50&page=${data}`);
    }
}

function editAddon(data: any) {
    return axiosInstance.get(`/admin/addons/${data.id}`);
}


function searchTicket(data: any) {
    let url = `/admin/tickets?limit=50`
    if (data.pageLimit) {
        url += `&page=${data.pageLimit}`
    }
    if (data.accountIdData && data.accountId) {
        url += `&${data.accountIdData}=${data.accountId}`
    }
    if (data.agentIdData && data.agentId) {
        url += `&${data.agentIdData}=${data.agentId}`
    }
    if (data.departmentIdData && data.departmentId) {
        url += `&${data.departmentIdData}=${data.departmentId}`
    }
    if (data.dueDateData && data.dueDate) {
        url += `&${data.dueDateData}=${data.dueDate}`
    }
    if (data.remainderDateData && data.remainderDate) {
        url += `&${data.remainderDateData}=${data.remainderDate}`
    }
    if (data.internalStatusData && data.internalStatus) {
        url += `&${data.internalStatusData}=${data.internalStatus}`
    }
    if (data.subjectData && data.subject) {
        url += `&${data.subjectData}=${data.subject}`
    }
    if (data.ticketStatusData && data.ticketStatus) {
        url += `&${data.ticketStatusData}=${data.ticketStatus}`
    }

    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/tickets?limit=50&page=${data}`);
    }
}

function searchWhite(data: any) {
    let url = `/admin/white-ips?limit=50`
    if (data.pageLimit) {
        url += `&page=${data.pageLimit}`
    }
    if (data.ipAddressData && data.ipAddress) {
        url += `&${data.ipAddressData}=${data.ipAddress}`
    }
    if (data.userNameData && data.userName) {
        url += `&${data.userNameData}=${data.userName}`
    }

    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/white-ips?limit=50&page=${data}`);
    }
}


function searchOutBound(data: any) {
    let url = `/admin/outbound-providers?limit=50&page=${data.pageLimit}`

    if (data.NameData && data.name !== '') {
        url += `&${data.NameData}=${data.name}`
    }
    if (data.ipAddressData && data.ipAddress !== '') {
        url += `&${data.ipAddressData}=${data.ipAddress}`
    }
    if (data.prefixData && data.prefix !== '') {
        url += `&${data.prefixData}=${data.prefix}`
    }
    if (data.statusData && data.status) {
        url += `&${data.statusData}=${data.status}`
    }
    if (data.days) {
        url += `&callDays=${data.days}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/outbound-providers?limit=50&page=${data}`);
    }
}

function searchE99Providers(data: any) {
    let url = `/admin/e911-provider?limit=50&page=${data.pageLimit}`
    if (data.NameData && data.name) {
        url += `&${data.NameData}=${data.name}`
    }
    if (data.ipAddressData && data.ipAddress) {
        url += `&${data.ipAddressData}=${data.ipAddress}`
    }
    if (data.prefixData && data.prefix) {
        url += `&${data.prefixData}=${data.prefix}`
    }
    if (data.statusData && data.status) {
        url += `&${data.statusData}=${data.status}`
    }

    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/e911-provider?limit=50&page=${data}`);
    }
}

function searchOutBoundCallLogs(data: any, value: any) {
    if (Object.keys(value).length) {
        return axiosInstance.get(`/admin/outbound-providers/${data}/callLogs?limit=50&page=${value.pageLimit}&${value.statusData}=${value.status}`);
    }
    else {
        return axiosInstance.get(`/admin/outbound-providers/${data}/callLogs?limit=50&page=${value}`);
    }
}

function searchInBound(data: any) {
    let url = `/admin/inbound-providers?limit=50&page=${data.pageLimit}`
    if (data.NameData && data.Name) {
        url += `&${data.NameData}=${data.Name}`
    }
    if (data.statusData && data.status) {
        url += `&${data.statusData}=${data.status}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/inbound-providers?limit=50&page=${data}`);
    }
}

function searchInBoundgetIP(data: any) {
    if (data.objct) {
        return axiosInstance.get(`/admin/inbound-providers/${data.id}/ips?${data.objct.ipAddressData}=${data.objct.ipAddress}&${data.objct.StatusData}=${data.objct.Status}`);
    }
    else {
        return axiosInstance.get(`/admin/inbound-providers/${data.id}/ips?limit=50`);
    }
}

function searchSms(data: any) {
    let url = `/admin/sms-providers?limit=50&page=${data.pageLimit}`
    if (data.NameData && data.name) {
        url += `&${data.NameData}=${data.name}`
    }
    if (data.statusData && data.status) {
        url += `&${data.statusData}=${data.status}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/sms-providers?limit=50&page=${data}`);
    }
}

function editSmsProvider(data: any) {
    return axiosInstance.get(`/admin/sms-providers/${data.id}`);
}


function VendorRate(data: any, value: any, sortByTotalCalls: any, sortByTotalConnectedCalls: any, sortByAcdFailure: any, sortByAcdSuccess: any, sortByAsrFailure: any, sortByAsrSuccess: any, sortByPddFailure: any, sortByPddSuccess: any, sortByQualityScore: any) {
    if (Object.keys(value).length) {
        return axiosInstance.get(`/admin/outbound-providers/${data}/rates?limit=50&page=${value.pageLimit}&${value.routeData}=${value.route}&${value.routeNameData}=${value.routeName}&${value.statusData}=${value.status}&totalCalls=${sortByTotalCalls}&totalConnectedCalls=${sortByTotalConnectedCalls}&acd_failure=${sortByAcdFailure}&acd_success=${sortByAcdSuccess}&asr_failure=${sortByAsrFailure}&asr_success=${sortByAsrSuccess}&pdd_failure=${sortByPddFailure}&pdd_success=${sortByPddSuccess}&qualityScore=${sortByQualityScore}`);
    }
    else {
        return axiosInstance.get(`/admin/outbound-providers/${data}/rates?limit=50&page=${value}&totalCalls=${sortByTotalCalls}&totalConnectedCalls=${sortByTotalConnectedCalls}&acd_failure=${sortByAcdFailure}&acd_success=${sortByAcdSuccess}&asr_failure=${sortByAsrFailure}&asr_success=${sortByAsrSuccess}&pdd_failure=${sortByPddFailure}&pdd_success=${sortByPddSuccess}&qualityScore=${sortByQualityScore}`);
    }
}

// function AllCall(data: any) {
//     if (Object.keys(data).length) {
//         return axiosInstance.get(`/admin/reports/calls?limit=50&page=${data.pageLimit}&${data.callNumber}=${data.callSearchKey}&${data.callFromDateData}=${data.startDate}&${data.remainderDateData}=${data.endDate}&${data.providerNameData}=${data.providerName}&${data.callTypeData}=${data.callType}&${data.callErrorData}=${data.callError}&${data.deviceTypeData}=${data.deviceType}&${data.callStatusData}=${data.callStatus}`);
//     }
//     else {
//         return axiosInstance.get(`/admin/reports/calls?limit=50&page=${data}`);
//     }
// }

function AllCall(data: any) {

    let url = `/admin/reports/calls?limit=50`

    if (data.pageLimit) {
        url += `&page=${data.pageLimit}`
    }
    if (data.typeData && data.type) {
        url += `&${data.typeData}=${data.type}`
    }
    if (data.callSearchKey) {
        url += `&value=${data.callSearchKey}`
    }
    if (data.callFromDateData && data.startDate) {
        url += `&${data.callFromDateData}=${data.startDate}`
    }
    if (data.remainderDateData && data.endDate) {
        url += `&${data.remainderDateData}=${data.endDate}`
    }
    if (data.providerNameData && data.providerName) {
        url += `&${data.providerNameData}=${data.providerName}`
    }
    if (data.callTypeData && data.callType) {
        url += `&${data.callTypeData}=${data.callType}`
    }
    if (data.callErrorData && data.callError) {
        url += `&${data.callErrorData}=${data.callError}`
    }
    if (data.deviceTypeData && data.deviceType) {
        url += `&${data.deviceTypeData}=${data.deviceType}`
    }
    if (data.callStatusData && data.callStatus) {
        url += `&${data.callStatusData}=${data.callStatus}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/reports/calls?limit=50&page=${data}`);
    }
}

function VendorReports(data: any) {
    let url = `/admin/reports/vendor-reports?limit=50&page=${data.pageLimit}`
    if (data.providerIdData && data.providerId) {
        url += `&${data.providerIdData}=${data.providerId}`
    }
    if (data.callStatusData && data.callStatus) {
        url += `&${data.callStatusData}=${data.callStatus}`
    }
    if (data.phrase) {
        url += `&phrase=${data.phrase}`
    }
    if (data.startDate) {
        url += `&startDate=${data.startDate}`
    }
    if (data.endDate) {
        url += `&endDate=${data.endDate}`
    }
    if (data.route) {
        url += `&route=${data.route}`
    }

    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`admin/reports/vendor-reports?limit=50&page=${data}`);
    }
}

function UsageReport(data: any) {
    let url = `admin/reports/usage`
    if (data.email) {
        url += `?email=${data.email}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/reports/usage`);
    }
}

function searchSmsReports(data: any) {
    let url = `/admin/reports/sms?limit=50&page=${data.pageLimit}`
    if (data.id && data.searchKey) {
        url += `&${data.id}=${data.searchKey}`
    }
    if (data.smsDirection && data.smsDirectionValue) {
        url += `&${data.smsDirection}=${data.smsDirectionValue}`
    }
    if (data.messageStatus && data.messageStatusValue) {
        url += `&${data.messageStatus}=${data.messageStatusValue}`
    }
    if (data.callFromDateData && data.startDate) {
        url += `&${data.callFromDateData}=${data.startDate}`
    }
    if (data.remainderDateData && data.endDate) {
        url += `&${data.remainderDateData}=${data.endDate}`
    }

    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/reports/sms?limit=50&page=${data}`);
    }
}

function callSimuation(data: any) {
    let url = `/admin/reports/call-simulation`
    if (data) {
        url += `?destNumber=${data}`
    }
    return axiosInstance.get(url);
}

function deviceProvision(data: any) {
    let url = `/admin/provision-devices?limit=50`
    if (data.pageLimit) {
        url += `&page=${data.pageLimit}`
    }
    if (data.nameData && data.name) {
        url += `&${data.nameData}=${data.name}`
    }
    if (data.codeData && data.code) {
        url += `&${data.codeData}=${data.code}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/provision-devices?limit=50&page=${data}`);
    }
}


function EditDeviceProvision(data: any) {
    return axiosInstance.get(`/admin/provision-devices/${data.id}`);
}

function profileModules(data: any) {
    let url = `/admin/profiles?limit=50`
    if (data.pageLimit) {
        url += `&page=${data.pageLimit}`
    }
    if(data.nameData && data.name){
        url += `&${data.nameData}=${data.name}`
    }
    if(data.statusData && data.status){
        url += `&${data.statusData}=${data.status}`
    }
    if (Object.keys(data).length) {
        return axiosInstance.get(url);
    }
    else {
        return axiosInstance.get(`/admin/profiles?limit=50&page=${data}`);
    }
}

function editProfile(data: any) {
    return axiosInstance.get(`/admin/profiles/${data.id}`);
}

function permissionSearch(data: any) {
    return axiosInstance.get(`/admin/profiles/${data.id}/permissions`);
}

function UserPermssion(data: any) {
    return axiosInstance.get(`/admin/permissions`);
}


